import React, {useEffect, useState} from "react"
import PropTypes from "prop-types"
import MetaTags from "react-meta-tags"
import {Container, Card, CardBody, Nav, NavItem, NavLink} from "reactstrap"
import classnames from "classnames"
import {withRouter} from "react-router"
import {withTranslation} from "react-i18next"
import DataTableRattrapage from "./DataTableRattrapage"
import AddRattrapage from "./AddRattrapage"
import DataTableRattrapageStat from "./DataTableRattrapageStat";

const Rattrapage = props => {
    const [section, setSection] = useState(1)
    const [add, setAdd] = useState(0);
    const [excel, setExcel] = useState(0);
    const [cloture, setCloture] = useState(0);
    const back = () => {
        setSection(1)
    }
    useEffect(async () => {
        var cloture_annee = JSON.parse(localStorage.getItem("cloture"));
        setCloture(cloture_annee)
        const userAuth = JSON.parse(localStorage.getItem('UserMenu'));
        const typeArticleSubMenu = userAuth.find(user =>
            user.sous_menu.some(subMenu => subMenu.sous_menu === "Avis de rattrapage")
        );
        setAdd(typeArticleSubMenu.sous_menu[0].add)
        setExcel(typeArticleSubMenu.sous_menu[0].exel)
    }, [])
    const renderBlock = section => {
        if (section === 1) {
            return <DataTableRattrapage/>
        } else if (section === 2) {
            return <AddRattrapage setSection={setSection} back={back}/>
        } else if (section === 3) {
            return <DataTableRattrapageStat setSection={setSection} back={back}/>
        }
    }

    return (
        <React.Fragment>
            <div className="page-content">
                <MetaTags>
                    <title>{props.t("Rattrapage")} | Cresus </title>
                </MetaTags>
                <Container fluid>
                    <div>
                        <Nav tabs>
                            <NavItem>
                                <NavLink
                                    style={{cursor: "pointer"}}
                                    className={classnames({
                                        active: section === 1,
                                    })}
                                    onClick={() => {
                                        setSection(1)
                                    }}
                                >
                                    {props.t("Rattrapage")}
                                </NavLink>
                            </NavItem>
                            {cloture != 1 ? (
                                add === 1 ? (
                                    <NavItem>
                                        <NavLink
                                            style={{cursor: "pointer"}}
                                            className={classnames({
                                                active: section === 2,
                                            })}
                                            onClick={() => {
                                                setSection(2)
                                            }}
                                        >
                                            {props.t("Ajouter rattrapage")}
                                        </NavLink>
                                    </NavItem>
                                ) : (null)
                            ) : (null)}
                            <NavItem>
                                <NavLink
                                    style={{cursor: "pointer"}}
                                    className={classnames({
                                        active: section === 3,
                                    })}
                                    onClick={() => {
                                        setSection(3)
                                    }}
                                >
                                    {props.t("Statistique de rattrapage")}
                                </NavLink>
                            </NavItem>
                        </Nav>
                        <Card>
                            <CardBody>{renderBlock(section)}</CardBody>
                        </Card>
                    </div>
                </Container>
            </div>
        </React.Fragment>
    )
}

export default withRouter(withTranslation()(Rattrapage))
Rattrapage.propTypes = {
    t: PropTypes.any,
}
